import * as z from 'zod'
import { validatePhone } from '@/lib/utils/validation/phoneValidation'
import { UTMDataSchema } from '@/lib/gtm/utmContext'

export const contactFormSchema = z.object({
  first_name: z.string().nonempty('กรุณาระบุชื่อของคุณ'),
  last_name: z.string().nonempty('กรุณาระบุนามสกุลของคุณ'),
  company: z.string().nonempty('กรุณาระบุชื่อบริษัทของคุณ'),
  position: z.string(),
  email: z.string().email().nonempty('กรุณาระบุอีเมล์ของคุณ'),
  tel: z
    .string()
    .nonempty('กรุณาระบุเบอร์โทรติดต่อของคุณ')
    .refine((value) => validatePhone(value), {
      message: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
    }),
  message: z.string(),
  terms_and_policy_consent: z
    .boolean()
    .refine((value) => value === true, {
      message: 'กรุณายอมรับเงื่อนไขและนโยบาย',
    }),
  marketing_consent: z.boolean(),
  url: z.string(),
})

export const payloadSchema = contactFormSchema.extend({
  utm: UTMDataSchema,
})

export type PayloadValue = z.infer<typeof payloadSchema>
